"use client"

import React from "react"
import Image from "next/image"

const LinkedInSocialProof = () => {
    return (
        <section id="LinkedInSocialProof" className="relative w-full bg-[#020617] py-20 md:py-28 overflow-hidden">

            {/* Background Glows */}
            <div className="absolute top-1/2 left-0 -translate-y-1/2 w-[600px] h-[600px] bg-blue-600/10 blur-[120px] rounded-full pointer-events-none" />
            <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-blue-500/5 blur-[140px] rounded-full pointer-events-none" />

            <div className="max-w-[1800px] mx-auto px-8 lg:px-12 relative z-10">
                <div className="grid grid-cols-1 lg:grid-cols-[0.95fr_1.05fr] gap-12 lg:gap-20 items-center">

                    {/* Left Column: Text Content */}
                    <div className="space-y-8 max-w-2xl">

                        <div className="flex items-center gap-3">
                            <span className="text-[#2563EB] text-[18px] md:text-[22px] font-bold  font-[family-name:var(--font-plus-jakarta-sans)]">
                                Global Audience
                            </span>

                            <div className="w-6 h-px bg-[#ffffff] mt-1" />
                        </div>

                        <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white leading-[1.1] tracking-tight font-[family-name:var(--font-plus-jakarta-sans)]">
                            A Distinctive Voice in Tech's New Frontier
                        </h2>

                        <p className="text-white/60 text-lg md:text-xl leading-relaxed font-[family-name:var(--font-plus-jakarta-sans)] max-w-xl">
                            With more than two decades bridging the dot-com era to the rise of cloud and blockchain—and now Agentic AI—I'm dedicated to sharing new pathways for leaders and organizations.
                        </p>
                    </div>

                    {/* Right Column: LinkedIn Card with Premium UI */}
                    <div className="relative group lg:pl-10">

                        {/* Background Layer (Smaller container visible behind) */}
                        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[95%] h-[92%] bg-[#163A98]/10 rounded-[40px] blur-sm transition-all duration-700 group-hover:bg-[#163A98]/20" />

                        {/* The Outer Card Container */}
                        <div className="relative z-10 bg-gradient-to-b from-white/[0.1] to-[#163A98]/30 p-[1px] rounded-[32px] overflow-hidden shadow-2xl">
                            <div className="bg-gradient-to-b from-[#02081A]/95 to-[#163A98]/40 backdrop-blur-2xl rounded-[31px]">

                                {/* Image Section: No top/bottom padding, significant left/right space */}
                                <div className="relative px-8 md:px-20 pt-0">

                                    {/* Small container visible in the back of the image container - Adjusted width */}
                                    <div className="absolute top-2 left-[9%] right-[9%] bottom-[-10px] bg-[#02081A]/80 rounded-[24px] blur-[2px]" />

                                    {/* Main Image Container */}
                                    <div className="relative w-full aspect-[21/9] md:aspect-[16/7] rounded-b-[24px] overflow-hidden border-x border-b border-white/5 shadow-2xl">
                                        <Image
                                            src="/images/image.png"
                                            alt="LinkedIn Social Proof UI"
                                            fill
                                            loading="lazy"
                                            className="object-cover object-bottom"
                                        />
                                    </div>
                                </div>

                                {/* Trusted By Section: Solid background at bottom */}
                                <div className="p-4 md:p-8 pt-6">
                                    <div className="flex items-center justify-center gap-4 py-2">
                                        <div className="bg-white p-2 rounded-lg shadow-lg">
                                            <svg className="w-8 h-8 md:w-10 md:h-10 text-[#0a66c2]" fill="currentColor" viewBox="0 0 24 24">
                                                <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z" />
                                            </svg>
                                        </div>
                                        <div className="flex flex-col md:flex-row items-baseline gap-1 md:gap-3">
                                            <span className="text-white text-xl md:text-4xl font-extrabold tracking-tighter">
                                                Trusted by
                                            </span>
                                            <span className="text-[#ff7a1a] text-xl md:text-4xl font-extrabold tracking-tighter">
                                                130k+ Audience
                                            </span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        {/* Radiant Glows focused on the card */}
                        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-[#163A98]/20 blur-[100px] pointer-events-none rounded-full opacity-40" />
                    </div>

                </div>
            </div>
        </section>
    )
}

export default LinkedInSocialProof
